import { IoMdClose } from 'react-icons/io';

function UpdateModal(props) {
  return (
    <div>
      <div className="w-80 sm:w-112 mx-auto fixed inset-0 flex items-center z-50">
        <div className = "w-80 sm:w-112 h-48 bg-white dark:bg-custom-gray rounded-xl dark:border-0 shadow-xl dark:shadow-[0px_0px_2px_#787878]">
          <div className = "h-12 flex justify-end w-112">
            <IoMdClose onClick={() => props.selectModal("")}
              className="flex text-xs mr-8 mt-4 md:text-xs lg:text-base font-medium text-zinc-400 cursor-pointer dark:text-gray-600 dark:text-gray-400 cursor-pointer"
              size={24}
            />
          </div>
          <div className = "flex items-center justify-center text-2xl font-semibold text-black dark:text-white">
            {
              props.status === "successUpdate"
                ?
              "Successfully updated information"
                :
              "Failed to update information"
            }
          </div>
          {
            props.status === "successUpdate"
              ?
            <div className = "text-md mt-4 mx-4 text-center text-zinc-400">
              Your information was updated successfully. You can view your new profile <a href={props.url} className="text-blue-400"> here </a>
            </div>
              :
            <div className = "text-md mt-4 mx-4 text-center text-zinc-400">
              Your information failed to update. This is likely because the username you provided is already taken
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default UpdateModal;